import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { Input } from '@descope/page-editor-components';
import { EditorInputSettings } from './EditorInputSettings';

type Props = React.ComponentProps<typeof Input>;

const EditorInput = (props: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLDivElement) => connect(drag(ref)),
		[connect, drag]
	);

	// we are setting the input to read only value so it won't pop validations error message when editing the page
	// on the generated page the input element will not be read only
	return <Input ref={refCb} {...props} readOnly />;
};

EditorInput.craft = {
	name: 'Input',
	props: {
		label: 'Input',
		size: 'md' as Props['size'],
		placeholder: 'Input',
		fullWidth: true,
		max: 100,
		required: false
	},
	custom: {
		type: 'input'
	},
	related: {
		settings: EditorInputSettings
	}
};

export { EditorInput };
